module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/g9xPuH/images/cover.jpg?1737031378273",
      "alt": "This image is the cover for the book 100 Desserts for $5 or Less"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("100 Desserts for $5 or Less\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Make delicious desserts for the entire family—for what a single slice of cake might cost you at a restaurant.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" These incredibly tasty, made-from-scratch cookies, bars, cakes, pies, candies, and frozen desserts are ideal for special occasions or every day. They also allow you to treat yourself, family, and friends for far less money!"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In addition to recipes, you’ll find calorie counts per serving and tips on how to navigate the grocery aisles, make healthier choices, and fight back against rising food costs while still indulging in some sweet luxury. Learn to make:"), _c('br'), _vm._v(" ·      Blackberry Crunch"), _c('br'), _vm._v(" ·      Sweet-Tart Lime Bars"), _c('br'), _vm._v(" ·      Caramel Apple Funbake"), _c('br'), _vm._v(" ·      Ginger Clove Cake"), _c('br'), _vm._v(" ·      Lemon Walnut Bites, and more\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Angel Shannon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Angel Shannon has been cooking up delicious dishes and sharing culinary tips and fun entertaining ideas on radio and television for more than 30 years. She recently started her own company, Cooking with Angel, Inc., and is the author of Stick of Butter Cookbook. She lives in northern Utah.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0